import { Typography, Box } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import { getCloudOrgStructureElement } from "slices/cloudOrgStructure";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

const registry = createLookupRegistry();

const NiceCloudOrgElementManagedBy = (props) => {
  const wantedResource = props.children;

  const element = useSelector((state) =>
    state.cloudOrgStructure?.data?.list?.find((org) => org.id === wantedResource)
  );

  useLookupOnce(
    registry,
    wantedResource,
    (id) => getCloudOrgStructureElement({ id }),
    { resolved: !!element, skip: wantedResource === "billingAccount" }
  );

  return (
    <>
      {element ? (
        <Box
          display="flex"
          justifyContent="start"
          alignItems="baseline"
          flexDirection={"column"}
        >
          <Typography>{element.name}</Typography>
          <Typography variant="small">{`(${element.resourceType})`}</Typography>
        </Box>
      ) : (
        <Box>{wantedResource}</Box>
      )}
    </>
  );
};

export default React.memo(NiceCloudOrgElementManagedBy);
